import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';
import Buefy from 'buefy';

export default {
  /*   categories() {
    return Firebase.firestore()
      .collection('display-categories')
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  }, */

  all() {
    return (
      Firebase.firestore()
        .collection('users')
        .where('role', '==', "agent")
        //.where('category', '==', category)
        .get()
        .then(docs => {
          return Firestore.getCollectionData(docs);
        })
    );
  },
  allAdmin() {
    return (
      Firebase.firestore()
        .collection('users')
        .where('role', '==', "admin")
        .get()
        .then(docs => {
          return Firestore.getCollectionData(docs);
        })
    );
  },

  //myJSON : JSON.stringify(availableQuantities),

  manageUser(user) {
    const {
      code,
      gst,
      area,
      name,
      state,
      city,
      pincode,
     mobile,
      email,
      address,
      owner,
      website,
      pan_img = null,
      profile_img = null,
      active = false,
      role = "agent"
    } = user;

    const userObj = {
      code,
      gst,
      area,
      name,
      state,
      city,
      pincode,
      owner,
      mobile,
      address,
      email,
      website,
      pan_img,
      profile_img,
      active,
      role
    };
    console.log(userObj);
    const promise = user.docId
      ? Firebase.firestore()
          .collection('users')
          .doc(user.docId)
          .update(userObj)
      : Firebase.firestore()
          .collection('users')
          .add(userObj);

    return promise;
  },

  deleteUser(user) {
    return Firebase.firestore()
      .collection('users')
      .doc(user)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/pages/users/service.js